module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<div class=\"row m-0\"> <div class=\"col-md-6 border-top-1 border-right-1 primary-method\"> <p class=\"text-uppercase text-muted my-4\">Primary Method</p> <div id=\"primary_loader\" class=\"loader left\"></div> <div id=\"primary_payment_method\"></div> </div> <div class=\"col-md-6 border-top-1 secondary-method\"> <p class=\"text-uppercase text-muted my-4\"> Backup Method <small class=\"fa fa-question-circle text-muted\" data-toggle=\"tooltip\" title=\"We will use this to fund your account in case the primary payment method fails to charge or has an outstanding transfer.<br><br>Bank transfers take up to 5 business days to process</strong>, so it is recommended that bank account users register a backup card to ensure on-demand funding while transfers are processed.\" data-placement=\"bottom\"></small> </p> <div id=\"secondary_loader\" class=\"loader left\"></div> <div id=\"secondary_payment_method\"></div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/billing/payment_methods/details_template.ejs
// module id = 1256
// module chunks = 1